import CssBaseline from '@material-ui/core/CssBaseline';
import { createContentfulManagementClient } from 'app/proxy/explora';
import { ExploraProvider } from 'app/store/explora-context';
import { supportsWebP } from 'explora-global';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createContentfulClient } from 'shared/util/contentful/contentful';
import App from './App';
import './index.scss';
import ReactGA from 'react-ga';
import * as serviceWorker from './serviceWorker';

createContentfulClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE as string,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN as string,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT as string,
});

createContentfulManagementClient({
  spaceId: process.env.REACT_APP_CONTENTFUL_SPACE as string,
  accessToken: process.env.REACT_APP_CONTENTFUL_MANAGEMENT_ACCESS_TOKEN as string,
  environmentId: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT as string,
});

const TRACKING_ID = "UA-158729935-1";
ReactGA.initialize(TRACKING_ID);
supportsWebP().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <ExploraProvider>
        <Router>
          <CssBaseline />
          <App />
        </Router>
      </ExploraProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
